<template>
    <v-container class="py-0">
        <CMRequests
            v-if="isAccountingUser && chatObjectType"
            :type="chatObjectType"
            :info="info"
            :smartMessages="chatMessagesNotReply"
            @sendMessage="sendMessage($event)"
            @insertQuestion="insertQuestion($event)"
        />
        <CMDocument
            v-else-if="chatObjectType === 'Document' && answersRequired && showChatManager"
            :id="id"
            :smartMessages="chatMessagesNotReply"
            :documentInfo="info"
            @answers="sendAnswers($event)"
            @reduce="reduce($event)"
        />
        <!-- <CMExpenseReport
            v-else-if="chatObjectType === 'ExpenseReport'"
            :id="id"
        ></CMExpenseReport> -->
        <v-row no-gutters v-if="!showChatManager && answersRequired">
            <v-col cols="12" class="d-flex justify-center">
                <v-btn-icon icon="$live_help" size="small" @click="reduce({ value: false })" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";

import CMDocument from "./CMDocument.vue";
import CMExpenseReport from "./CMExpenseReport.vue";
import CMRequests from "./CMRequests.vue";

import CHAT from "../../graphql/chat/Chat.gql";
import CREATE_MESSAGE from "../../graphql/chat/CreateMessage.gql";
import SEND_SMART_CHAT_ANSWERS from "../../graphql/chat/SendSmartChatAnswers.gql";
import { User } from "../../store/store";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        CMDocument,
        CMExpenseReport,
        CMRequests,
    },
    emits: ["chatID", "questionsNotReply", "showDiscussion", "allAsksResponded", "textToInsert"],
})
export class ChatManager extends Vue {
    @Prop({ default: "" }) id: string;
    @Prop({ default: "OBJECT" }) chatType: string;

    answersRequired = false;

    showChatManager = true;

    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }
    get isAccountingUser() {
        return this.currentUser.isAccountingUser;
    }

    get documentId() {
        if (this.chatObjectType === "Document") {
            return this.$route.params.id;
        }
        return "";
    }

    @Apollo({
        query: CHAT,
        variables() {
            return {
                id: this.id,
                type: this.chatType,
            };
        },
        skip() {
            // debugger
            // return (this.chatType === "OBJECT" && !this.id) || this.chatType !== "COMPANY";
            return this.chatType !== "OBJECT" || !this.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                // debugger
                this.$emit("questionsNotReply", { value: false });
                if (data?.chats?.length) {
                    const chat = data.chats[0];
                    if (chat.document && chat.document.id) {
                        this.chatObjectType = "Document";
                        this.info.id = chat.document.id;
                        this.info.type = chat.document.type;
                        console.log("infoDoc", this.info);
                    } else if (chat.expenseReport) {
                        this.chatObjectType = "ExpenseReport";
                    } else {
                        this.chatObjectType = null;
                    }
                } else {
                    this.chatObjectType = null;
                }
                if (data && data.chatMessages) {
                    this.chatMessagesNotReply = data.chatMessages;
                    console.log("questions", this.chatMessagesNotReply);
                    if (data.chatMessages.length) {
                        this.$emit("questionsNotReply", { value: true });
                        this.answersRequired = true;
                        this.showChatManager = true;
                        if (!this.isAccountingUser) {
                            this.$emit("showDiscussion", { value: false });
                        }
                    }
                }
            }
        },
    })
    chatObjectType: any = null;

    info: any = {};

    chatMessagesNotReply: any = null;

    beforeMount() {
        if (!this.id) {
            this.autoDetection();
        }
    }

    sendMessage = async function sendingTheMessage(message: any) {
        const chat = await this.$apollo.mutate({
            mutation: CREATE_MESSAGE,
            variables: {
                chatId: this.id,
                chatType: this.chatType,
                companyId: this.selectedCompany.id,
                userId: this.currentUser.id,
                message: message.message,
                type: message.type,
            },
        });
        debugger;
        this.$emit("textToInsert", message.message);
        this.$emit("chatID", chat.data.createMessage.id);

        try {
            this.chatMessagesNotReply.push({ smartAsk: message.type });
        } catch (e) {
            this.chatMessagesNotReply = [{ smartAsk: message.type }];
            debugger;
        }
    };

    insertQuestion(message: { type: string; message: string }) {
        this.$emit("textToInsert", message.message);
    }

    autoDetection = function autoPageTypeDetection() {
        switch (this.$route.name) {
            case "document": {
                this.chatObjectType = "Document";
            }
        }
    };

    sendAnswers = async function SendingAnswersToDataBase({ data, ...rest }) {
        const answeredAll = this.chatMessagesNotReply.length === data.length;
        if (data.length) {
            await this.$apollo.mutate({
                mutation: SEND_SMART_CHAT_ANSWERS,
                variables: {
                    answers: {
                        answers: data,
                        chatId: this.id,
                        userId: this.currentUser.id,
                        companyId: this.selectedCompany.id,
                        documentId: this.documentId,
                        fileType: this.chatObjectType,
                        answeredAll: this.chatMessagesNotReply.length === data.length,
                    },
                },
            });
            if (answeredAll) {
                this.$emit("allAsksResponded");
            }
        }
        if (this.chatMessagesNotReply.length === data.length) {
            this.answersRequired = false;
            this.reduce({ value: true });
        }
    };

    reduce = function reduceChatManagerPart({ value }) {
        this.$emit("showDiscussion", { value: value });
        this.showChatManager = !value;
    };
}

export default toNative(ChatManager);
</script>

<style scoped>
.oss-btn-chat {
    transition: all 0.25s 0;
    animation: componentAnimate 2s infinite;
}

@keyframes componentAnimate {
    0% {
        background-color: #5fc9b8;
        border-color: #5fc9b8;
    }
    50% {
        background-color: #f8f8f8;
        border-color: #f8f8f8;
    }
    to {
        background-color: #5fc9b8;
        border-color: #5fc9b8;
    }
}
</style>
